import type { AnalyticsSender } from '@funtech-int/yango-shared';

import { playerContentPreparedV2 } from '@kinopoisk-int/evgen-web-events/web/player';

import type { PlayerBaseInfoContent } from '../../player-manager/context/PlayerBaseInfoProvider';

import { playerContentPrepared } from './event-params-builders/player-content-prepared';

export interface PlayerContentPreparedAnalyticsParams {
    contentId: string;
    psid: string;
    manifestUrl: string;
    vsid: string;
    isDynamicPrerollEnabled: boolean;
    content: PlayerBaseInfoContent;
}

export const createAnalyticsEvents = (eventSender: AnalyticsSender) => ({
    playerContentPrepared(params: PlayerContentPreparedAnalyticsParams) {
        eventSender.send(playerContentPreparedV2, playerContentPrepared(params));
    },
});
